import {
  getTeam,
  getTeams,
  createTeam,
  getTeamsUsers,
  editTeamDetails,
  removeTeam,
  exportTeams,
  bulkEditTeamsUsers,
  getBgEventTasks,
  teamsFileUpload,
} from 'util/Api/teams';
import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
export const resetTeamAdded = createAction('teams/resetTeamAdded');

export const fetchTeam = createAsyncThunk(
  'teams/fetchTeam',
  async ({ customerId, teamId }, { rejectWithValue }) => {
    try {
      return await getTeam({ customerId, teamId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchTeams = createAsyncThunk(
  'teams/fetchTeams',
  async ({ customerId, page, itemsPerPage, filter, sort }, { rejectWithValue }) => {
    try {
      return await getTeams({ customerId, page, itemsPerPage, filter, sort });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchUsersOnTeam = createAsyncThunk(
  'teams/fetchUsersOnTeam',
  async (
    { customerId, page, itemsPerPage, filter, phone, teamFqdn, sort },
    { rejectWithValue },
  ) => {
    try {
      return await getTeamsUsers({
        customerId,
        page,
        itemsPerPage,
        filter,
        phone,
        teamFqdn,
        sort,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchUsersNotOnTeam = createAsyncThunk(
  'teams/fetchUsersNotOnTeam',
  async (
    { customerId, page, itemsPerPage, filter, phone, teamFqdn, sort },
    { rejectWithValue },
  ) => {
    try {
      return await getTeamsUsers({
        customerId,
        page,
        itemsPerPage,
        filter,
        phone,
        teamFqdn,
        sort,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addTeam = createAsyncThunk(
  'teams/addTeam',
  async ({ customerId, teamName, parentTeamId }, { rejectWithValue }) => {
    try {
      return await createTeam({ customerId, teamName, parentTeamId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchParentTeams = createAsyncThunk(
  'teams/fetchParentTeams',
  async ({ customerId, page, searchValue }, { rejectWithValue }) => {
    try {
      const filter = [{ fieldName: 'name', type: 'Like', value: searchValue }];

      return await getTeams({ customerId, page, itemsPerPage: 50, filter });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const editTeam = createAsyncThunk(
  'teams/editTeam',
  async ({ customerId, teamId, teamName, teamOptOutMessage }, { rejectWithValue }) => {
    try {
      return await editTeamDetails({
        customerId,
        teamId,
        teamName,
        teamOptOutMessage,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const bulkActionTeamUsers = createAsyncThunk(
  'teams/bulkActionTeamUsers',
  async ({ customerId, users, action }, { rejectWithValue }) => {
    try {
      return await bulkEditTeamsUsers({ customerId, users, action });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const deleteTeam = createAsyncThunk(
  'teams/deleteTeam',
  async ({ customerId, teamId }, { rejectWithValue }) => {
    try {
      return await removeTeam({ customerId, teamId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const downloadTeams = createAsyncThunk(
  'teams/downloadTeams',
  async ({ customerId }, { rejectWithValue }) => {
    try {
      return await exportTeams({ customerId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchBgEventTasks = createAsyncThunk(
  'teams/fetchBackgroundEvents',
  async ({ pageNumber, itemsPerPage, userName, teamId }, { rejectWithValue }) => {
    try {
      return await getBgEventTasks({ pageNumber, itemsPerPage, userName, teamId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const teamsImport = createAsyncThunk(
  'teams/teamsImport',
  async ({ uploadHeaders, customerId, uid }, { rejectWithValue }) => {
    try {
      return await teamsFileUpload({
        uploadHeaders,
        customerId,
        uid,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
